import './App.scss';
import Logo from './assets/logo/logo.png';
import Video from './assets/video/video.mp4';
import Image1 from './assets/images/1.png';
import Image2 from './assets/images/2.png';
import Image3 from './assets/images/3.png';
function App() {
  return (
    <>
      <header>
        <div className='container'>
          <div className='header-alignment'>
            <img src={Logo} alt='Logo' />
            <div className='two-button-alignment'>
              <a className='docu' target='_blank' href='https://geminiai-document.netlify.app/'>Document</a>
              <a target='_blank' href='https://codecanyon.net/item/gimi-ai-content-generation-and-image-generation-flutter-application/52469847'>
                <button>
                  Buy Now
                </button>
              </a>
            </div>
          </div>
        </div>
      </header>
      <div className='hero-banner'>
        <div className='container'>
          <div className='grid'>
            <h1>
              Introducing Gemini AI Your Gateway to
              Intelligent Exploration and Creativity
            </h1>
            <video src={Video} alt="Video" autoPlay muted loop></video>
            <p>
              Gemini AI revolutionizes the way you interact with technology by integrating advanced artificial intelligence into a single, user-friendly application. Built with Flutter for seamless cross-platform functionality, Gemini AI ensures a smooth experience on both Android and iOS devices. Enjoy the convenience of Supabase Authentication for secure login, including the option to use Google for quick access. With a real-time database, your data and chat history are always at your fingertips. Whether you're generating stunning visuals from simple descriptions or diving into diverse topics with instant answers, Gemini AI empowers your curiosity and creativity like never before. Welcome to a new era of discovery and innovation with Gemini AI.
            </p>
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='all-spacer'>
          <h4>Key Features</h4>
          <div className='all-grid-alignment'>
            <div className='new-grid'>
              <div className='new-grid-items'>
                <img src={Image1} alt='Image1' />
              </div>
              <div className='new-grid-items'>
                <h2>Explore Your Questions
                </h2>
                <p>
                  GeminiAI provides a seamless way to explore various questions across different categories. Whether you're looking to understand advancements in technology or seeking advice on personal finance, time management, or self-improvement, GeminiAI offers curated suggestions to help you navigate through your queries. The intuitive interface categorizes common questions, making it easier to find the information you need to enhance your personal growth, self-care, health, and relationships.

                </p>
              </div>
            </div>
            <div className='new-grid'>
              <div className='new-grid-items'>
                <img src={Image2} alt='Image2' />
              </div>
              <div className='new-grid-items'>
                <h2>Get Direct Answers
                </h2>
                <p>
                  Tired of battling AI-generated content? Utilize our cutting-edge AI Detection Remover to bypass AI detector tools and eradicate AI plagiarism, transforming your writing into authentic, human-like prose. Connect with your audience on a deeper level as you infuse personality and emotion into
                  every word, setting your content apart in a sea of automation.
                </p>
              </div>
            </div>
            <div className='new-grid'>
              <div className='new-grid-items'>
                <img src={Image3} alt='Image3' />
              </div>
              <div className='new-grid-items'>
                <h2>Generate Images
                </h2>
                <p>
                  GeminiAI also features an innovative image generation tool, allowing users to create custom images effortlessly. Whether you need illustrations for a project, want to visualize a concept, or simply have fun creating art, GeminiAI can generate images based on your input. This tool empowers you to bring your ideas to life with high-quality visuals, enhancing your creativity and productivity.

                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default App;
